import React from "react";
import { AlertTriangle, Clock, Upload, Timer } from "lucide-react";

/**
 * AttentionTiles — colour-keys reference theme tokens so contrast stays
 * AA in both dark and light themes. Active tile uses a tinted background
 * built from the same token via color-mix so it blends correctly on
 * either surface.
 */
const TILES = [
  {
    key: "awaiting_reply",
    label: "Awaiting reply",
    icon: Clock,
    cssVar: "--st-in-design-fg",
    testid: "tile-awaiting-reply",
  },
  {
    key: "overdue",
    label: "Overdue",
    icon: AlertTriangle,
    cssVar: "--st-on-hold-fg",
    testid: "tile-overdue",
  },
  {
    key: "stalled",
    label: "Stalled",
    icon: Timer,
    cssVar: "--st-construction-fg",
    testid: "tile-stalled",
  },
  {
    key: "recent_uploads",
    label: "Recent client uploads",
    icon: Upload,
    cssVar: "--st-planning-fg",
    testid: "tile-recent-uploads",
  },
];

export function AttentionTiles({ data, activeKey, onSelect }) {
  return (
    <div
      className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-8"
      data-testid="attention-tiles"
    >
      {TILES.map(({ key, label, icon: Icon, cssVar, testid }) => {
        const count = (data?.[key] ?? []).length;
        const isActive = activeKey === key;
        const colorRef = `var(${cssVar})`;
        return (
          <button
            key={key}
            onClick={() => onSelect(isActive ? null : key)}
            className="card-surface text-left px-5 py-4 transition-all hover-lift"
            style={
              isActive
                ? {
                    outline: `1.5px solid ${colorRef}`,
                    background: `color-mix(in srgb, ${colorRef} 12%, transparent)`,
                  }
                : {}
            }
            data-testid={testid}
          >
            <div className="flex items-center justify-between mb-3">
              <span
                className="text-[10px] uppercase tracking-[0.18em] font-semibold"
                style={{ color: isActive ? colorRef : "var(--atech-text-muted)" }}
              >
                {label}
              </span>
              <Icon
                size={13}
                style={{ color: isActive ? colorRef : "var(--atech-text-muted)" }}
              />
            </div>
            <div
              className="font-display text-3xl leading-none"
              style={{ color: count > 0 ? colorRef : "var(--atech-text-muted)" }}
            >
              {data ? count : "—"}
            </div>
          </button>
        );
      })}
    </div>
  );
}
